




















import { Component, Emit, PropSync, Ref } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { AtomTextField } from '@/components/atoms'

export interface InputFreeWords {
  input: string
  errorMessage: string
}

export const defaultInputFreeWords = (): InputFreeWords => ({
  input: '',
  errorMessage: ''
})

@Component({
  components: {}
})
export default class BibliographyFreeWordSearch extends ComponentVue {
  @PropSync('input', {
    type: Object
  })
  inputItem!: InputFreeWords

  @Ref()
  atomTextField!: AtomTextField

  focus(): void {
    this.atomTextField.atomTextField.focus()
  }

  existsErrorMessage(errorMessage: string): boolean {
    return !!errorMessage
  }

  resetErrorMessage(obj: any): void {
    obj.errorMessage = ''
  }

  @Emit('keydown:enter')
  onKeydownEnter(): void {}
}
